import { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import {
  Button,
  Input,
  SubTitle,
} from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Row, Spinner } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
// import EditBusinessTypeModal from "../../Components/Modals/EditBusinessTypeModal.js";
import { RiEditFill } from "react-icons/ri";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import SelectFieldComponent from "../../Components/CustomComponents/SelectFieldComponent.js";
import ToolTip from "../../Components/CustomComponents/ToolTip.js";
import EditPollRuleModal from "../../Components/Modals/EditPollRuleModal.js";
import {
  useDeletePollRuleMutation,
  useGetAllPollRulesQuery,
  useUpdatePollRuleMutation,
} from "../../Data/services/pollRuleApi.js";
import { useGetAllProductQuery } from "../../Data/services/productApi.js";

const PollRulesManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllPollRulesQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);

      if (data.data.length === 0) {
        setIndicationMessage("Data not available");
      }
    }
  }, [data]);

  const [selectedType, setSelectedType] = useState("");

  const [update, { isLoading: updating }] = useUpdatePollRuleMutation();

  const handleDynamicTypeChange = async (value, row) => {
    console.log(value);
    console.log(row);
    setSelectedType(value);

    const data = {
      title: row.title,
      description: row.description,
      image_url: row.image_url,
      product_id: value,
    };

    try {
      const response = await update({
        data: data,
        id: row.id,
      }).unwrap();
      console.log(response);

      if (response.code === 200) {
        refetch();
        SuccessToast(response?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);

    // debouncedSearch(query);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const [deletePollRule, { isLoading: isDeleting }] =
    useDeletePollRuleMutation();

  const deleteData = async (slug) => {
    try {
      const { data } = await deletePollRule(slug);
      // console.log(data);
      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "title",
      text: "Title",
      // sort: true,
      headerStyle: {
        // width: "200px",
      },
    },

    {
      dataField: "description",
      text: "Description",
      headerAlign: "center",
      align: "center",
      // sort: true,
      headerStyle: {
        // width: "200px",
      },
      formatter: (cellContent, row) => {
        return (
          <span className="lc-2">
            {cellContent ? cellContent : "No description available"}
          </span>
        );
      },
    },

    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        // width: "100px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.slug || row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <ToolTip placement={"top"} content={"Edit"}>
                <div
                  className={` d-flex justify-content-center align-items-center bg-primary-hover rounded-3 p-2 mx-2 `}
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleEditModalOpen(true);
                  }}
                >
                  <span
                    className={`align-items-center d-flex justify-content-center `}
                  >
                    <RiEditFill />
                  </span>
                  {/* <span>Edit</span> */}
                </div>
              </ToolTip>

              <ToolTip placement={"top"} content={"Delete"}>
                <div
                  className="d-flex justify-content-center align-items-center bg-danger-hover rounded-3 p-2 mx-2 "
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleDeleteModalOpen();
                  }}
                >
                  <span className={`d-flex align-items-center`}>
                    <MdDeleteForever />
                  </span>
                  {/* <span>Delete</span> */}
                </div>
              </ToolTip>
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditPollRuleModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Poll Rules Management"} classes="" />
        </div>

        {
          <Row>
            <Col md={12}>
              <Button
                classes={`${styles.cardBtn} `}
                text="Add More"
                onClick={handleAddUser}
              ></Button>
            </Col>
          </Row>
        }
      </div>

      <div
        className={`${styles.mainTable} ${
          dataFetched && isFetching ? "blur-table" : ""
        }`}
      >
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            <div className="d-flex justify-content-end align-items-center gap-2">
              <span style={{ width: "250px" }}>
                <Input
                  type="search"
                  placeholder="Search by name"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </span>
            </div>
            {
              <Table
                classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                refetch={refetch} // todo
                // refetch={() => {}} // todo
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default PollRulesManagementScreen;
